module.exports = __webpack_public_path__ + "media/images/mastercard-logo-6c49de103e5b0ee5668c2d55187f3e53.svg";